import {
  GET_RCA,
  GET_RCA_FAIL,
  GET_RCA_SUCCESS,
  GET_RCA_BY_ID,
  GET_RCA_BY_ID_FAIL,
  GET_RCA_BY_ID_SUCCESS,
  POST_RCA,
  POST_RCA_FAIL,
  POST_RCA_SUCCESS,
  POST_FULL_RCA,
  POST_FULL_RCA_FAIL,
  POST_FULL_RCA_SUCCESS,
  UPDATE_RCA_IMPACT,
  UPDATE_RCA_IMPACT_FAIL,
  UPDATE_RCA_IMPACT_SUCCESS,
  UPDATE_RCA_TIMELINE,
  UPDATE_RCA_TIMELINE_FAIL,
  UPDATE_RCA_TIMELINE_SUCCESS,
  UPDATE_RCA_QUESTIONS,
  UPDATE_RCA_QUESTIONS_FAIL,
  UPDATE_RCA_QUESTIONS_SUCCESS,
  UPDATE_RCA_ACTIONS,
  UPDATE_RCA_ACTIONS_FAIL,
  UPDATE_RCA_ACTIONS_SUCCESS,
  UPDATE_RCA_RELATED_ALERTS,
  UPDATE_RCA_RELATED_ALERTS_FAIL,
  UPDATE_RCA_RELATED_ALERTS_SUCCESS,
  UPDATE_RCA_RELATED_RCAS,
  UPDATE_RCA_RELATED_RCAS_FAIL,
  UPDATE_RCA_RELATED_RCAS_SUCCESS,
  UPDATE_RCA_IMPACTED_APPLICATIONS,
  UPDATE_RCA_IMPACTED_APPLICATIONS_FAIL,
  UPDATE_RCA_IMPACTED_APPLICATIONS_SUCCESS,
  GET_ACTION_ITEM_BY_ID,
  GET_ACTION_ITEM_BY_ID_FAIL,
  GET_ACTION_ITEM_BY_ID_SUCCESS,
  UPDATE_RCA_INCIDENT_DETAILS_SUCCESS,
  UPDATE_RCA_INCIDENT_DETAILS,
  UPDATE_RCA_INCIDENT_DETAILS_FAIL,
  UPDATE_RCA_HEADER_DETAILS,
  UPDATE_RCA_HEADER_DETAILS_SUCCESS,
  UPDATE_RCA_HEADER_DETAILS_FAIL,
  UPDATE_ACTION_STATUS,
  UPDATE_ACTION_STATUS_SUCCESS,
  UPDATE_ACTION_STATUS_FAIL,
  CLEAR_RCA_DATA,
} from "./actionTypes"

const INIT_STATE = {
  rcas: [],
  rca_by_id: {
    "events":[],
    "impact": {},
    "rca_timelines":[],
    "related_alerts": [],
    "related_past_rcas": [],
    "timeline_images": {},
    "action_items":[],
    "impact_images":[],
    "impacted_application_services":[],
    "question_images":{},
    "questions":[],
    "rca" : {
      "created_at" : "",
      "created_by" : "",
      "description": "",
      "id" : "",
      "organization": {},
      "organization_id" : "",
      "owner": "",
      "reviewer": "",
      "status" : "",
      "title" : "",
      "updated_at" : "",
      "updated_by" : "",
    }
  },
  response: [],
  action_item: {}
}

const Rca = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_RCA:
      return {
        ...state,
        error: action.payload,
      }

    case GET_RCA_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_RCA_SUCCESS:
      return {
        ...state,
        rcas: action.payload,
      }

    case GET_RCA_BY_ID:
      return {
        ...state,
        error: action.payload,
      }

    case GET_RCA_BY_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_RCA_BY_ID_SUCCESS:
      return {
        ...state,
        rca_by_id: action.payload,
      }

    case GET_ACTION_ITEM_BY_ID:
      return{
        ...state,
        error: action.payload
      }

    case GET_ACTION_ITEM_BY_ID_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case GET_ACTION_ITEM_BY_ID_SUCCESS:
      return{
        ...state,
        action_item: action.payload
      }

    // case POST_RCA:
    //   return{
    //     ...state,
    //     error: action.payload
    //   }
    //
    // case POST_RCA_FAIL:
    //   return{
    //     ...state,
    //     error: action.payload
    //   }
    //
    // case POST_RCA_SUCCESS:
    //   return{
    //     ...state,
    //     response: action.payload
    //   }

    case POST_FULL_RCA:
      return{
        ...state,
        error: action.payload
      }

    case POST_FULL_RCA_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case POST_FULL_RCA_SUCCESS:
      return{
        ...state,
        response: action.payload
      }

    case UPDATE_RCA_IMPACT:
      return{
        ...state,
        error: action.payload
      }

    case UPDATE_RCA_IMPACT_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case UPDATE_RCA_IMPACT_SUCCESS:
      return{
        ...state,
        rca_by_id: {
          ...state.rca_by_id,
          impact: action.payload
        }
      }

    case UPDATE_RCA_ACTIONS:
      return{
        ...state,
        error: action.payload
      }

    case UPDATE_RCA_ACTIONS_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case UPDATE_RCA_ACTIONS_SUCCESS:
      return{
        ...state,
        rca_by_id: {
          ...state.rca_by_id,
          action_items: [
            ...(action.payload?.short_term_actions || []),
            ...(action.payload?.long_term_actions || [])
          ]
        }
      }

    case UPDATE_RCA_QUESTIONS:
      return{
        ...state,
        error: action.payload
      }

    case UPDATE_RCA_QUESTIONS_FAIL:
    return{
      ...state,
      error: action.payload
    }

    case UPDATE_RCA_QUESTIONS_SUCCESS:
      return{
        ...state,
        rca_by_id: {
          ...state.rca_by_id,
          questions: action.payload
        }
    }

    case UPDATE_RCA_INCIDENT_DETAILS:
      return{
        ...state,
        error: action.payload
      }

    case UPDATE_RCA_INCIDENT_DETAILS_SUCCESS:
      return {
        ...state,
        rca_by_id: {
          ...state.rca_by_id,
          rca: {
            ...state.rca_by_id.rca,
            description: action.payload?.rca?.description
          }
        }
     }

    case UPDATE_RCA_INCIDENT_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload
      }

    case UPDATE_RCA_HEADER_DETAILS:
      return{
        ...state,
        error: action.payload
      }

    case UPDATE_RCA_HEADER_DETAILS_SUCCESS:
      return{
        ...state,
        rca_by_id: {
          ...state.rca_by_id,
          rca: {
            ...state.rca_by_id.rca,
            owner: action.payload?.rcaHeaderDetails?.owner,
            reviewer: action.payload?.rcaHeaderDetails?.reviewer,
            title: action.payload?.rcaHeaderDetails?.title,
            status: action.payload?.rcaHeaderDetails?.status
          }
        }
      }

    case UPDATE_RCA_HEADER_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload
      }

    case UPDATE_ACTION_STATUS:
      return{
        ...state,
        error: action.payload
      }

    case UPDATE_ACTION_STATUS_SUCCESS:
      return{
        ...state,
        response: action.payload
      }

    case UPDATE_ACTION_STATUS_FAIL:
      return {
        ...state,
        error: action.payload
      }
    case UPDATE_RCA_TIMELINE:
      return{
        ...state,
        error: action.payload
      }

    case UPDATE_RCA_TIMELINE_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case UPDATE_RCA_TIMELINE_SUCCESS:
      return{
        ...state,
        rca_by_id: {
          ...state.rca_by_id,
          rca_timelines: action.payload
        }
      }

    case UPDATE_RCA_RELATED_ALERTS:
      return{
        ...state,
        error: action.payload
      }

    case UPDATE_RCA_RELATED_ALERTS_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case UPDATE_RCA_RELATED_ALERTS_SUCCESS:
      return{
        ...state,
        rca_by_id: {
          ...state.rca_by_id,
          related_alerts: action.payload
        }
      }

    case UPDATE_RCA_RELATED_RCAS:
      return{
        ...state,
        error: action.payload
      }

    case UPDATE_RCA_RELATED_RCAS_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case UPDATE_RCA_RELATED_RCAS_SUCCESS:
      return{
        ...state,
        rca_by_id: {
          ...state.rca_by_id,
          related_past_rcas: action.payload
        }
      }

    case UPDATE_RCA_IMPACTED_APPLICATIONS:
      return{
        ...state,
        error: action.payload
      }

    case UPDATE_RCA_IMPACTED_APPLICATIONS_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case UPDATE_RCA_IMPACTED_APPLICATIONS_SUCCESS:
      return{
        ...state,
        rca_by_id: {
          ...state.rca_by_id,
          impacted_application_services: action.payload
        }
      }

    case CLEAR_RCA_DATA:
      return {
        ...state,
        rca_by_id: []
      };

    default:
      return state;  

    }
  }

export default Rca;